export var shadows = {
  boxShadow: '0 1px 3px 0 rgba(46, 46, 51, 0.25)',
  buttonShadow: '0 1px 2px 0 rgba(46, 46, 51, 0.25), 0 1px 3px 1px rgba(46, 46, 51, 0.15)',
  boxHoverShadow: '0 4px 16px 0 rgba(46, 46, 51, 0.15)',
  extraBlack: '0 4px 24px rgba(46, 46, 51, 0.08), 0 4px 8px rgba(229, 229, 229, 0.8)',
  mediumBlack: '0 0 16px rgba(46, 46, 51, 0.04)',
  lightBlack: '0 0 4px rgba(46, 46, 51, 0.04)',
  innerBlack: 'inset 0 0 4px #D5D5D6',
  innerBlue: 'inset 0 0 8px rgba(213, 213, 214, 0.5)'
};